/** Where each "Learn more" goes: the Pushly AI docs, and Brand Voice's own page within them. */
export const PUSHLY_AI_DOCS_URL = 'https://documentation.pushly.com/platform/notifications/pushly-ai'
export const BRAND_VOICE_DOCS_URL = `${PUSHLY_AI_DOCS_URL}/brand-voice`
